/// User will select debt and/or on going  and/or one time payments to pay for

import React from 'react';
import Parent from '../../common/parent';
import { withTranslation } from 'react-i18next';
import BuildingTitle from '../../common/buildingTitle';
import BackToPersonalDetails from '../../common/payment_flow/backToPersonalDetails';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import PaymentLastPageSingleComponent from '../../common/payment_flow/paymentLastPageSingleComponent';
import { constants } from '../../common/constants/constants';
import creditCard from '../../images/credit-card.png';
import CacheData from '../../common/utils/cacheData';
import LastConfirmationPageLogic from './lastConfirmationPageLogic';
import PayerDetailsSummary from '../../common/payment_flow/payerDetailsSummary';
import UpComingMonths from '../../common/order_status/upComingMonths';
import './paymentLastCheckoutPage.css';
import {GAEvent} from '../../common/google_analytics/google_analytics';
import CreditCardChoiceModal from '../../managers/credit_card/CreditCardChoiceModal/CreditCardChoiceModal';
import ConfirmationModal from '../../managers/credit_card/ConfirmationModal/ConfirmationModal';
import {AutoBankChargePopup} from '../../managers/autoBankCharge/AutoBankChargePopup';
import {StyledModal} from '../../common/shared/modal.styled';
import {Modal} from 'react-bootstrap';
import {NotificationManager} from "react-notifications";

export class PaymentsLastCheckoutPage extends Parent {
    constructor(props) {
        super(props);
        document.title = props.t('titles.payment_checkout');

        this.t = props.t;
        this.state = this.newState(props);
        this.helper = new LastConfirmationPageLogic({
            client: this.client,
            buildingID: this.state.buildingID,
            apartmentNumber: this.state.apartmentNumber,
        });
        this.state.creditCardsData = [];
        this.state.showCreditCardChoiceModal = false;
        this.state.showConfirmationModal = false;
        this.state.showBankChargePopup = false;
        this.state.showAutoChargePopup = false;
        this.state.paymentID = ''
    }

    mapByPaymentId = (cards = []) => {
        let cardsMap = {};

        for (const card of cards) {
            cardsMap[card.paymentID] = card;
        }

        return cardsMap
    }

    fetchCreditCardsData = async () => {
        this.startLoader();
        // const isAdmin = await this.isAdmin();
        const response = await this.client.get(`/managers/operations/apartmentDetails/${this.state.buildingID}/${this.state.apartmentNumber}`);

        let cards = response.lastCreditCards4Digits;
        // opening charge from past bank charge to all
        // if (!isAdmin){
        //     // temp, till this is working in production
        //     cards = cards.filter(c=>{return c.expiry});
        // }
        this.setState({
            ...this.state,
            creditCardsData: cards,
            cardsByPaymentId: this.mapByPaymentId(cards)
        });

        if (this.state.creditCardsData.length !== 0) {
            this.setState({
                ...this.state,
                paymentID: this.state.creditCardsData[0].paymentID
            });
        }

        this.endLoader();
    }


    async componentDidMount() {
        try {
            const isViewedByManager = await this.isLoggedIn();
            const isAdmin = await this.isAdmin();
            const { currency } = await this.fetchBuildingData(this.state.buildingID);
            if (isViewedByManager){
                await this.verifyLoggedIn();
                let client = await this.getAuthenticatedClient();
                this.helper = new LastConfirmationPageLogic({
                    client: client,
                    buildingID: this.state.buildingID,
                    apartmentNumber: this.state.apartmentNumber,
                });
                await this.fetchCreditCardsData();
            }
    
    
            this.genericBinds(this.props.history);
            this.setState({
                isAdmin,
                currency
            });
            await this.reloadPage();
        } catch (e) {
            return;
        }
    }

    onContinueAndBackClicked = async evt => {
        evt.preventDefault();
        let noApartmentDetailsAvailableToChargeFrom = this.state.creditCardsData.length === 0;
        if (noApartmentDetailsAvailableToChargeFrom) {
            await this.helper.handleContinueClicked(this.state.continueToPaymentUrl, this);
        } else {
            this.setState({
                ...this.state,
                showCreditCardChoiceModal: true
            })
        }
    }

    redirectToChoosePayment = () => window.location.href = `/${constants.pages.choosePaymentMethod}/${this.state.buildingID}`;

    onCreditCardChoiceModalHide = () => {
        this.setState({
            ...this.state,
            showCreditCardChoiceModal: false
        })
    }

    onRadioChange = value => {
        this.setState({
            ...this.state,
            paymentID: value
        })
    }

    onConfirmationModalHide = () => {
        this.setState({
            ...this.state,
            showConfirmationModal: false
        })
    }

    onContinueModalBtnClick = async radioValue => {
        if (radioValue === 'newCard') await this.helper.handleContinueClicked(this.state.continueToPaymentUrl, this);
        else {
            await this.onCreditCardChoiceModalHide();
            this.setState({
                ...this.state,
                showConfirmationModal: true
            })
        }
    }

    onChargeModalBtnClick = async () => {
        let cardData = this.state.cardsByPaymentId[this.state.paymentID];
        const isBankCharge = !!cardData.bankCode;
        const isChargeCart = true;
        const cartId = await this.helper.handleContinueClicked(this.state.continueToPaymentUrl, this, false, isBankCharge, isChargeCart);
        this.startLoader();
        const response = await this.client.post('/managers/operations/charge-cart/', {
            cartID: cartId,
            paymentID: this.state.paymentID,
            last4Digits: cardData.cardLast4Digits,
            isBankCharge: !!cardData.bankCode
        });
        this.endLoader()

        if (response.success) {
            window.location.href = `/status/${cartId}`
        }else{
            // todo translate
            NotificationManager.error('תשלום נדחה על ידי חברת האשראי', '', 5000);
        }
        this.setState({
            ...this.state,
            showConfirmationModal: false
        })
    }

    onBankAllowClick = async evt => {
        evt.preventDefault();
        this.setState({ showBankChargePopup: true });
        GAEvent(constants.GoogleAnalytics.Events.payment, 'clickedBankAllow', 1, 'clickedBankAllow');
    }
    /**
     * @param {{
     *     imageBase64: string,
     *     imageName: string,
     *     bankCode: { value: string };
     *     branchNumber: string;
     *     accountNumber: string;
     *     date: string;
     *     ownerId: string;
     * }} data
     * */
    async handleAutoBankChargePopupSuccess(data) {
        this.setState({ showAutoChargePopup: false });
        this.startLoader();
        try {
            const bankChargeData = this.bankChargePayload(data);

            const constChargeDateKeyData = { buildingID: this.state.buildingID, apartmentNumber: this.state.apartmentNumber }
            const chargeDate = CacheData.fetchCache('onGoingChargeDate', constChargeDateKeyData);
            CacheData.cache('onGoingChargeDate', {...chargeDate, selected: data.date}, constChargeDateKeyData);

            const plan = await this.helper.createBankChargePaymentPlan(this, data.imageBase64, data.imageName, bankChargeData);
            CacheData.cache(`cartID`, plan.paymentResult.cartID);
            NotificationManager.success(this.t('auto_charge.success'), '', 5000);
            // TODO: consider to redirect user to another page on success
        } catch (e) {
            NotificationManager.error(this.t('auto_charge.failed'));
        } finally {
            this.endLoader();
        }
    }

    /**
     * @param {{
     *     imageBase64: string,
     *     imageName: string,
     *     bankCode: { value: string };
     *     branchNumber: string;
     *     accountNumber: string;
     *     date: string;
     *     ownerId: string;
     * }} data
     * */
    bankChargePayload(data){
        const payload = {
            bankCode: Number(data.bankCode.value),
            branchNumber: Number(data.branchNumber),
            accountNumber: Number(data.accountNumber)
        }

        BllinkLogger.info(`bankChargePayload for payment `, payload);
        return payload

    }

    async handleBankChargeGuideClick(evt) {
        evt.preventDefault();
        this.startLoader();
        try {
            // requested by rayee and mor that this guide will not close those months for now.
            // todo: call this **with true** only after
            // the user finished the guide and uploaded a digital signature
            const plan = await this.helper.createPaymentPlan(this, false);
            // todo cache the tenant details longer here due to bugs where the cart is lost before the image is uploaded
            CacheData.cache(`cartID`, plan.cartID);
            NotificationManager.success(this.t('auto_charge.success'), '', 5000);
            window.open(evt.target.href);
        } catch (e) {
            NotificationManager.error(this.t('auto_charge.failed'));
        } finally {
            this.endLoader();
            this.setState({ showBankChargePopup: false });
        }
    }

    rerender = async () => {
        await this.reloadPage();
    }

    newState(props) {
        const buildingID = props.match.params.buildingID;
        const apartmentNumber = props.match.params.apartmentNumber;
        // this.state.maxDebtInstallments  was added due to a bug on changing in debt installments on this page (was reset to one)
        // https://app.asana.com/0/1196545425570329/1198004758013409 - [Bug] confirm selection page, debt change installments
        const maxDebtFromBuildingCache = this.fetchMaxDebtInstallmentsFromCache(props.match.params.buildingID);
        const maxDebtInstallments = maxDebtFromBuildingCache || props.maxDebtInstallments || this.state.maxDebtInstallments || 1;
        const isViewedAsManager = this.props.match.path.includes(constants.pages.lastConfirmPaymentManagerPageUrl);
        const paymentSelectUrl = isViewedAsManager ? constants.pages.paymentSelectionTabForManager : constants.pages.paymentSelectionUrl;

        let data = {
            buildingID: buildingID,
            apartmentNumber: apartmentNumber,
            onGoingInstallments: this.onGoingSettings(buildingID, apartmentNumber, isViewedAsManager),
            pastPaymentsInstallments: this.pastPaymentsSettings(buildingID, apartmentNumber, maxDebtInstallments, isViewedAsManager),
            oneTimePaymentsInstallments: this.oneTimePaymentsSettings(buildingID, apartmentNumber),
            tenantDetails: CacheData.fetchCache('tenantDetails'),
            backUrl: '/' + paymentSelectUrl + '/' + buildingID + '/' + apartmentNumber,
            continueToPaymentUrl: '/' + constants.pages.paymentDetailsUrl,
            downloadBankBillingPdfUrl: `https://bllink-application.s3.amazonaws.com/documents/harshaa.pdf`,
            maxDebtInstallments: maxDebtInstallments,
            hasCommission: props.tenantCommission > 0,
            tenantCommission: props.tenantCommission,
            isViewedAsManager: isViewedAsManager
        };
        data.nextMonthsPaymentsData = LastConfirmationPageLogic.calcNextMonthsPayments({
                onGoing: data.onGoingInstallments,
                past: data.pastPaymentsInstallments,
                oneTime: data.oneTimePaymentsInstallments,
                // the commission will displayed on the title and not on the actual payments
                // https://app.asana.com/0/1198916940064392/1199513783310746
                options: {commission: 0}
            });

        return data;
    }

    reloadPage = async () => {
        const buildingData = await this.fetchBuildingData(this.props.match.params.buildingID);
        if (buildingData){
            BllinkLogger.info(`${this.constructor.name} adding building data `, buildingData);
            let newState = await this.newState({
                ...this.props,
                // required for past payments to take this data. solved bug https://app.asana.com/0/1196545425570329/1198004758013409
                maxDebtInstallments: buildingData.numberOfInstallmentsForDebt,
                tenantCommission: buildingData.tenantCommission

            })
            this.setState({
                ...newState,
                buildingFeatures: buildingData.features,
                address: buildingData.address,
                apartmentNumbers: buildingData.allNumbers,
                maxDebtInstallments: buildingData.numberOfInstallmentsForDebt,
                loadedBuildingData: true,
            });
        }
    }

    renderHiddenTenantDetailsPopUp() {
        const {t} = this.props;

        return this.renderHiddenPopUp({
            title: t('payments.tenant_details_missing_title'),
            id: 'tenantDetailsMissing',
            textLine1: t('payments.tenant_details_missing_text'),
        })

    }

    renderHiddenEmptyCartPopUp() {
        const {t} = this.props;

        return this.renderHiddenPopUp({
            title: t('payments.cart_empty_title'),
            id: 'cartIsEmpty',
            textLine1: t('payments.cart_empty_text'),
        })
    }

    renderMonthRelated() {
        const {t} = this.props;

        const hasNoMonthRelatedPayments = (
            this.state.pastPaymentsInstallments.total === 0  &&
            this.state.onGoingInstallments.total === 0
        )
        if (hasNoMonthRelatedPayments) {
            return <div/>
        }

        return (
            <div className="row set_RoW_1 pt-5 row-last-page-before-cc">
                <PaymentLastPageSingleComponent
                    title={t('payments.pay_debt')}
                    settings={this.state.pastPaymentsInstallments}
                    typeOfPayment={constants.cache.keys.payments.pastPayments}
                    onChange={this.rerender}

                />
                <PaymentLastPageSingleComponent
                    title={t('payments.on_going_title')}
                    settings={this.state.onGoingInstallments}
                    typeOfPayment={constants.cache.keys.payments.onGoingPayments}
                    onChange={this.rerender}
                />

            </div>
        )

    }

    renderOneTime() {

        const hasOneTimePayments = (
            this.state.oneTimePaymentsInstallments  &&
            this.state.oneTimePaymentsInstallments.length > 0
        )
        if (!hasOneTimePayments) {
            return <div/>
        }

        return (
            <div className="row set_RoW_1 pt-5 row-last-page-before-cc">
                {this.state.oneTimePaymentsInstallments.map((payment, index) => {
                    const selectName = constants.cache.keys.payments.oneTimeInstallmentsName(
                        payment.building_one_time_payment_id
                    );

                    return (<PaymentLastPageSingleComponent
                        key={index}
                        settings={payment}
                        typeOfPayment={selectName}
                        onChange={this.rerender}
                    />)
                })}
            </div>
        )
    }

    openAutoChargeModal = evt => {
        evt.preventDefault();
        this.setState({
            showAutoChargePopup: true,
            showBankChargePopup: false
        });
    }

    renderBankAllowPopUp() {
        const {t} = this.props;

        return(
            <StyledModal
                show={this.state.showBankChargePopup}
                dialogClassName="bank-charge"
                onHide={() => this.setState({showBankChargePopup: false})}
                centered
            >
                <Modal.Header>
                    <Modal.Title>{t('payments.call_us_for_bank_allow_title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-center">{t('payments.setup_using_this_flow_1')}</p>
                    <p className="text-center">{t('payments.setup_using_this_flow_2')}
                        <a rel="noopener noreferrer"
                           target="_blank"
                           onClick={evt => this.handleBankChargeGuideClick(evt)}
                           href={`/${constants.pages.bankChargeUrl}`}
                        >{t('payments.setup_using_this_flow_3')}</a>
                    </p>
                    <p className="text-center">{t('payments.setup_using_this_flow_4')}</p>

                    <button className="bllink-button w-100" onClick={this.openAutoChargeModal}>
                        {t('payments.setup_auto_charge')}
                    </button>
                </Modal.Body>
            </StyledModal>
        );
    }

    renderPaymentsAndTenantDetails() {
        const {t} = this.props;

        return (
            <div className="container">
                <div className="p-dept-section col-md-12">
                    <BackToPersonalDetails
                        buildingID={this.state.buildingID}
                        onNextBackChange={this.bindBackNextClickedFunc}
                        isViewedAsManager={this.state.isViewedAsManager}
                    />
                    <BuildingTitle
                        address={this.state.address}
                        apartmentNumber={this.state.apartmentNumber}
                    />
                </div>

                <div id="payment-heading">
                    <p>{t('payments.sub_title_before_payment')}</p>
                </div>

                {/* todo unify both under the same row div row set_RoW_1 pt-5 row-last-page-before-cc. same as order status page  */}
                {this.renderMonthRelated()}
                {this.renderOneTime()}

                <div className="container">   {/*container is for aligning width to be same as payments selections on mobile*/}
                    <div className="set_RoW_1">
                        <PayerDetailsSummary
                            payerDetails={this.state.tenantDetails}
                            toggle={true}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderUpComingMonths() {
        const {t} = this.props;

        return (
            <div className="container">
                <div className="row">
                    <UpComingMonths
                        paymentDetails={this.state.paymentDetails}
                        nextMonthsPaymentsData={this.state.nextMonthsPaymentsData}
                        tenantCommission={this.state.tenantCommission}
                    />

                    <div className="last-sec-bottom col-md-12">
                        <div className="col-md-12 p-0 checkout-page-explain-strip">

                            <div className="row">
                                <div className="col-md-3 d_19 "/>
                                <div className="col-md-5 d_19_2 "/>
                                <div className="col-md-4 d_19_3" />
                            </div>
                        </div>
                        <div className="col-md-12 p-0">
                            <div className="content_left-2">
                                <div className="col-md-12 p-0">
                                    <div className="row">
                                        <div className="col-md-3 d_19 ">
                                            <a href={this.state.backUrl} className="btn-13 js-href">{t('payments.back')}</a>
                                        </div>
                                            <div className="col-md-5 d_19_2 mr-auto">
                                                {this.state.buildingFeatures?.disableBankCharge === 'true' ? '' : (
                                                    <a href={this.state.downloadBankBillingPdfUrl}
                                                    className="btn_11 checkout-btn"
                                                    title="harshaa"
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                    download={t('payments.harshaaFileName')}
                                                    id="bankAllowLink"
                                                    onClick={this.onBankAllowClick}
                                                    >
                                                        {t('payments.pay_with_bank_permission')}
                                                    </a>
                                                )}
                                            </div>
                                            <div className="col-md-4 d_19_3">
                                                <a
                                                    href={this.state.continueToPaymentUrl}
                                                    className="btn_11 checkout-btn"
                                                    id='continue-to-card-details'
                                                    onClick={this.onContinueAndBackClicked}
                                                >
                                                    <img id="credit-card-logo" alt='credit-card' src={creditCard}/>
                                                    {t('payments.pay_credit_card')}
                                                </a>
                                            </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        BllinkLogger.info(`render last checkout `, this.state);
        this.setBodyClasses(constants.backgroundOptions.checkout);
        //todo validate this.state.tenantDetails is not empty (can happen if cache is cleared or someone sent the link to someone else)

        return (
            <div>
                <section>
                    <div className="loader-middle-2"/>
                    {this.renderPaymentsAndTenantDetails()}
                </section>

                <section>
                    {this.renderUpComingMonths()}
                </section>

                <CreditCardChoiceModal
                    buildingId={this.state.buildingID}
                    apartmentNumber={this.state.apartmentNumber}
                    show={this.state.showCreditCardChoiceModal}
                    onHide={this.onCreditCardChoiceModalHide}
                    creditCardsData={this.state.creditCardsData}
                    onContinueClick={this.onContinueModalBtnClick}
                    currentRadio={this.state.paymentID}
                    onRadioChange={this.onRadioChange}
                />

                <ConfirmationModal
                    show={this.state.showConfirmationModal}
                    onHide={this.onConfirmationModalHide}
                    onChargeClick={this.onChargeModalBtnClick}
                />

                {this.renderBankAllowPopUp()}

                {this.renderHiddenEmptyCartPopUp()}
                {this.renderHiddenTenantDetailsPopUp()}

                <AutoBankChargePopup
                    show={this.state.showAutoChargePopup}
                    address={this.state.address}
                    apartmentNumber={this.state.apartmentNumber}
                    tenantDetails={this.state.tenantDetails}
                    currency={this.state.currency}
                    onHide={() => this.setState({showAutoChargePopup: false})}
                    onSuccess={(data) => this.handleAutoBankChargePopupSuccess(data)}
                />
            </div>
        )
    }
}



export default withTranslation()(PaymentsLastCheckoutPage);
